import { useState } from "react"

import Layout from "../components/Layout"
import CustomerCard from "../components/dashboard/CustomerCard"
import OrderHistoryCard from "../components/dashboard/OrderHistoryCard"
import ComplaintCard from "../components/dashboard/ComplaintCard"
import OrderCard from "../components/dashboard/OrderCard"

const Dashboard = () => {
  const [customer, setCustomer] = useState(null)

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container-fluid">
          <div className="row g-3">
            <section className="col-md-6">
              <CustomerCard customer={customer} setCustomer={setCustomer} />
              {/* <OrderHistoryCard customer={customer} /> */}
              <ComplaintCard customer={customer} />
            </section>
            <aside className="col-md-6">
              <OrderCard customer={customer} />
            </aside>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Dashboard
